import {
  Button,
  Divider,
  Typography,
} from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_0, SPACING_2, SPACING_3 } from 'constants/theme-constants';
import styled, { css } from 'styled-components';

export const TabsWrapper = styled.div`
  ${({ theme }) => `
      overflow-x: scroll;
      scroll-behavior: smooth;
      display: flex;
      gap: ${cxTheme.spacing[SPACING_2]};
      
      &::-webkit-scrollbar {
          display: none;
      }
  `}
`;

export const TabsBottomDivider = styled(Divider)`
  box-shadow: ${({ theme }) => theme.elevation.level4};

  background-color: ${({ theme }) => theme.background.surface};
  border-top: 1px solid ${({ theme }) => theme.border.subtle};
  border-top-width: 1px;
`;

export const MarketTab = styled(Button)<{ $selected: boolean }>`
  all: unset;
  position: relative;
  height: ${({ theme }) => cxTheme.spacing[9]};
  padding: ${({ theme }) =>
    `${cxTheme.spacing[SPACING_0]} ${cxTheme.spacing[SPACING_3]}`};
  color: ${({ theme, $selected }) =>
    $selected
      ? theme.onSurface.surface.default.text.strong
      : theme.onSurface.surface.default.text.subtle};
  ${Typography.label.medium.bold};
  white-space: nowrap;

  user-select: none;

  &:hover {
    cursor: pointer;
  }

  &::after,
  &:active {
    ${({ $selected, theme }) =>
      $selected &&
      css`
        content: '';
        position: absolute;
        display: block;
        background-color: rgba(255, 198, 0, 1);
        height: 3px;
        right: 0;
        left: 0;
        bottom: 0;
      `};
  }
`;
